module.exports = __webpack_public_path__ + "img/Card.e717ecf9.webp";